// TODO find a working way to import a css file as text
export const printCss = `
* {
  box-sizing: border-box;
  -moz-box-sizing: border-box;
}

html {
  font-family: Calibri, Candara, Segoe, "Segoe UI", Optima, Arial, sans-serif;
  --page-padding: 2cm;
}

body {
  margin: 0;
  padding: 0;
}

.page {
  position: relative;
  width: 21cm;
  height: 29.7cm;
  padding: var(--page-padding);
  margin: 1cm auto;
  border: 1px #D3D3D3 solid;
  background: white;
  box-shadow: 0 0 5px rgba(0, 0, 0, 0.1);
  page-break-after: always;
}

.footer {
  position: absolute;
  bottom: var(--page-padding);
  left: var(--page-padding);
  right: var(--page-padding);
  display: flex;
  justify-content: space-between;
  margin: 0 20pt;
}


@media print {
  @page {
    size: auto;
    margin: 0;
  }

  .page {
    margin: 0;
    border: initial;
    width: initial;
    height: initial;
    box-shadow: initial;
    background: initial;
  }

  .footer {
    position: fixed;
  }
}

h1 {
  font-size: 18pt;
  text-align: center;
  margin-top: 0;
}

p {
  font-size: 8pt;
}

.label {
  margin: 0;
  font-weight: bold;
  font-size: 9pt;
}

.text {
  white-space: pre;
}

.input {
  border: 1px solid black;
  padding: 2pt 4pt;
}

.input.large {
  font-size: 10pt;
  font-weight: bold;
}

p.input {
  margin: 2pt 0 6pt;
}

span.input {
  margin-left: 8pt;
}

table {
  border-collapse: collapse;
  width: 100%;
  margin-bottom: 8pt;
}

table, th, td {
  border: 1px solid black;
}

th {
  text-align: center;
  font-size: 8pt;
}

td {
  font-size: 8pt;
  padding: 2pt 4pt;
}

.grid {
  display: grid;
  grid-column-gap: 20pt;
  grid-template-columns: 1fr 1fr;
}

.footer p {
  width: 120pt;
  border-top: 1px solid black;
  padding: 4pt 0;
  margin: 0;
  text-align: center;
}
`;


// WEBPACK FOOTER //
// ./src/print/printCss.ts